var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Administration Espace Salarié")])
}
var staticRenderFns = []

export { render, staticRenderFns }